import {IUserApi} from '../../api/user-api.service';
import {IUser} from '../../api/api.types';

export default class UserManagementController {
    private static readonly $inject = ['userApi', '$state'];

    private userList: IUser[];
    selectedUsers: IUser[] = [];
    userListPromise:ng.IPromise<any>;

  constructor(private userApi: IUserApi) {
    let self = this;
    self.userListPromise = userApi.getUserList()
        .then(function (data) {
            self.userList = data;
        });
  }

}



/** WEBPACK FOOTER **
 ** ./app/hydromet/userManagement/userManagement.controller.ts
 **/